import apiClient from './api';

export interface DashboardStats {
  date: string;
  date_fin: string;
  interventions_du_jour: number;
  en_attente: number;
  affectee: number;
  en_deplacement: number;
  en_cours: number;
  cloturee: number;
  validee: number;
  annulee: number;
  terminees: number;
  urgentes: number;
  critiques: number;
}

/**
 * Service API pour le tableau de bord
 */
export const dashboardService = {
  /**
   * Recupere les statistiques d'un jour ou d'une tranche de dates (demande
   * utilisateur : filtre par date/tranche sur le tableau de bord). Sans
   * argument, comportement par defaut inchange (statistiques du jour reel).
   */
  async getStats(date?: string, dateFin?: string): Promise<DashboardStats> {
    const params = new URLSearchParams();
    if (date) params.set('date', date);
    if (dateFin) params.set('date_fin', dateFin);
    const query = params.toString();
    const response = await apiClient.get<DashboardStats>(`/deneignements/stats${query ? `?${query}` : ''}`);
    return response.data;
  },
};

export default dashboardService;
